// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-skeleton-loader[data-v-2dbca3e4]  .v-skeleton-loader__chip{height:40px;width:100%}.v-skeleton-loader[data-v-2dbca3e4]  .v-skeleton-loader__image{height:100%}.nft-card-row[data-v-2dbca3e4]  .second-col{justify-content:flex-start!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
